var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtilizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46578 11.9565C8.48444 11.9565 10.9316 9.50939 10.9316 6.49073H5.46578L5.46581 1.02493C2.44713 1.02491 0 3.47205 0 6.49073C0 9.50939 2.44711 11.9565 5.46578 11.9565Z",
    fill: "#59B974"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85706 0V4.04678H11.6148V3.75772C11.6148 1.68239 9.93239 0 7.85706 0Z",
    fill: "#59B974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizationIcon);
export default __webpack_public_path__ + "static/media/UtilizationIcon.0dec95163a518b0c7cf57f938d2128bd.svg";
export { ForwardRef as ReactComponent };